import { inject } from '@angular/core';
import { CanActivateFn, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { isScullyRunning } from '@scullyio/ng-lib';
import { AuthService } from '@challenger/care/services/auth.service';
import { OAuthService } from 'angular-oauth2-oidc';

export const authGuard: CanActivateFn = (route, state): Observable<boolean> | boolean | UrlTree => {
  const oauthService = inject(OAuthService);

  if (!isScullyRunning()) {
    if (
      !(
        oauthService.getIdToken() !== null &&
        oauthService.getAccessToken() !== null &&
        oauthService.hasValidAccessToken()
      )
    ) {
      
      if (window.location.pathname !== '/help/how-to/auth-deflection') {
        sessionStorage.setItem('vmo2_seo_returnUrl', window.location.pathname);
      }  

      oauthService.initImplicitFlow();
      return false;
    }
  }

  return true;
};
